import { useState, useEffect } from '@wordpress/element';
import { __ }                  from '@wordpress/i18n';
import { getWishlistIds, onWishlistChange } from '../../../utils/wishlist';

export default function WishlistInlineIcon( { padding } ) {
	const [ ids, setIds ] = useState( () => getWishlistIds() );

	useEffect( () => {
		return onWishlistChange( ( newIds ) => setIds( [ ...newIds ] ) );
	}, [] );

	const count = ids.length;

	function handleOpen() {
		document.dispatchEvent( new CustomEvent( 'mwsb:open-wishlist' ) );
	}

	const btnStyle = {};
	if ( padding && typeof padding === 'object' ) {
		if ( padding.top )    btnStyle.paddingTop    = padding.top;
		if ( padding.right )  btnStyle.paddingRight  = padding.right;
		if ( padding.bottom ) btnStyle.paddingBottom = padding.bottom;
		if ( padding.left )   btnStyle.paddingLeft   = padding.left;
	}

	return (
		<button
			className="mwsb-wishlist-inline-btn"
			aria-label={ __( 'Wishlist', 'mwsb' ) }
			onClick={ handleOpen }
			style={ Object.keys( btnStyle ).length ? btnStyle : undefined }
		>
			<HeartIcon filled={ count > 0 } />
			{ count > 0 && <span className="mwsb-wishlist-inline-btn__count">{ count }</span> }
		</button>
	);
}

function HeartIcon( { filled } ) {
	return (
		<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
			<path
				d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
				fill={ filled ? 'currentColor' : 'none' }
				stroke="currentColor"
				strokeWidth={ filled ? '0' : '2' }
			/>
		</svg>
	);
}
